import { Component, OnInit } from '@angular/core';

import { Reservation, Company} from '../../shared/models';

import { ApiService } from '../../shared/services/api.service';
import { StorageService } from '../../shared/services/storage.service';

import { Utils } from '../../shared/helpers/utils';
import { Constants } from '../../shared/helpers/constants';

import { faXmark, faChevronUp, faChevronDown, faWhatsapp } from '../../icons';

@Component({
    selector: 'app-my-reservations',
    templateUrl: './my-reservations.component.html',
    styleUrls: ['./my-reservations.component.scss'],
    standalone: false
})
export class MyReservationsComponent implements OnInit {
	reservations: Reservation[];
	companies: {[id: number]: Company} = {};
  updatesInterval: any;

  // icons
  faXmark = faXmark;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  faWhatsapp = faWhatsapp;

  constructor(private api: ApiService,
  						private stor: StorageService) { }

  ngOnInit(): void {
  	this._loadReservations();
    if(!this.updatesInterval) {
      this.updatesInterval = setInterval(() => {
        this._loadReservations()
      }, 10000);
    }
  }

  goBack() {
  	history.back();
  }

  toggleReservation(res: Reservation) {
  	res.expand = !res.expand;
  }

  sendWhatsapp(res: Reservation) {
    let whatsMsg = `Olá, meu nome é ${res.customer_name} e tenho uma reserva para a data ${res.schedule}.
Sobre a minha reserva, 
`;

    let encodedMsg = encodeURIComponent(whatsMsg);

    window.open(`https://wa.me/55${this.companies[res.company_id].whatsapp_number}?text=${encodedMsg}`, "_blank");
  }
  cancel(res: Reservation) {
    if(confirm("Deseja realmente cancelar sua reserva?")) {
      this.api.show('reservations', 'cancel', {
        reservation_token: res.reservation_token
      }).subscribe(
        res => {
          console.log(res);
          alert("Reserva cancelada");
        },
        err => {
          console.log(err);
          alert("Esta reserva não pôde ser cancelada. Por favor, entre em contato com o estabelecimento");
        }
      );
    }
  }

  private _loadReservations() {
    this.reservations = [];
  	let aux = this.stor.getInLocal('reservations');
  	for(let reserv of aux) {
      this.api.show('reservations', reserv.id, {
        reservation_token: reserv.reservation_token
      }).subscribe(
        res => {
          let reserv2: Reservation = res.reservation;
          reserv2.schedule = Utils.dateToString(reserv2.schedule, false, true);
          reserv2.dayOfWeek = Constants.daysOfWeekPtbr[new Date(Utils.datePtBrToISO(reserv2.schedule)).getDay()];
          Reservation.setAdditionalData(reserv2);
          reserv2.companyName = reserv.companyName;

          if(!this.companies[reserv2.company_id]) {
            this.api.show('companies', reserv2.company_id).subscribe(
              res => {
                Company.setAdditionalData(res.company);
                reserv2.companyName = res.company.prettyName;
                this.companies[res.company.id] = res.company;
              },
              err => {
                console.log(err);
              }
            );
          }

          this.reservations.push(reserv2);
        },
        err => {
          console.log(err);
          if(this.updatesInterval) {
            clearInterval(this.updatesInterval);
          }
        }
      );
  	}
  }
}
